import { AlertTriangle, CheckCircle2, Trash2 } from 'lucide-react-native';
import React, { memo } from 'react';
import { Text, View } from 'react-native';

import { Color } from '@/styles/GlobalStyles';

import { styles } from './styles';

type IRowProps = {
  id: number;
  form: string;
  startDate: string;
  duration: string;
  status: string;
};

function RowComponent({ id, form, startDate, duration, status }: IRowProps) {
  const getIcon = (currentStatus: string) => {
    switch (currentStatus) {
      case 'Descartada':
        return <Trash2 style={styles.icon} stroke={Color.gray[300]} />;
      case 'Válida':
        return (
          <CheckCircle2 style={styles.icon} stroke={Color.secondary.green} />
        );
      case 'Não Considerada':
        return (
          <AlertTriangle style={styles.icon} stroke={Color.secondary.red} />
        );

      default:
        // Default fallback
        return <CheckCircle2 style={styles.icon} stroke={Color.gray[300]} />;
    }
  };

  return (
    <View style={styles.rows}>
      <View style={[styles.row]}>
        <Text style={[styles.text]}>{id}</Text>
      </View>
      <View style={[styles.row]}>
        <Text style={[styles.text]} numberOfLines={2} ellipsizeMode="tail">
          {form}
        </Text>
      </View>
      <View style={[styles.row]}>
        <Text style={[styles.text]}>{startDate}</Text>
      </View>
      <View style={[styles.row]}>
        <Text style={[styles.text]}>{duration}</Text>
      </View>
      <View style={[styles.row, styles.status]}>
        {getIcon(status)}
        <Text style={[styles.text]}>{status}</Text>
      </View>
    </View>
  );
}

export const Row = memo(RowComponent);
